import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import ContentLoader, { Rect } from 'react-content-loader/native';
import { StyleProp, ViewStyle } from 'react-native';

const kSubHeight = 15;
const kMargin1 = 20;
const kMargin2 = 8;

export const TaskContentLoader = memo(
  ({
    width,
    height,
    foregroundColor,
    backgroundColor,
    style,
  }: {
    width: number;
    height: number;
    foregroundColor: string;
    backgroundColor: string;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { rpx } = useResponsiveContext();

    const subHeight = rpx(kSubHeight);
    const margin1 = rpx(kMargin1);
    const margin2 = rpx(kMargin2);
    const topRectHeight = height - subHeight * 2 - margin2 * 2 - margin1;

    return (
      <ContentLoader
        key={width}
        speed={2}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
        style={style}
      >
        <Rect
          x={0}
          y={0}
          rx={rpx(20)}
          ry={rpx(20)}
          width={width}
          height={topRectHeight}
        />
        <Rect
          x={0}
          y={topRectHeight + margin1}
          width={width}
          height={subHeight}
          rx={subHeight / 2}
          ry={subHeight / 2}
        />
        <Rect
          x={0}
          y={topRectHeight + margin1 + subHeight + margin2}
          width={width * 0.75}
          height={subHeight}
          rx={subHeight / 2}
          ry={subHeight / 2}
        />
      </ContentLoader>
    );
  },
);
